// Engine entry point. Dispatches by format to the right diff implementation.
// Text (with an automatic prose track-changes path), JSON/YAML, and CSV/TSV
// have semantic engines; unknown formats fall back to the safe stub.
import { diffText } from './text-diff.js';
import { diffProse, looksLikeProse } from './prose-diff.js';
import { diffJson } from './json-diff.js';
import { diffCsv } from './csv-diff.js';
import { runCompare as stubCompare } from './stub.js';
import { diffParquet } from './parquet-diff.js';

export function compare(payload = {}) {
  const format = payload.format || 'text';
  if (format === 'parquet') return diffParquet(payload);
  if (format === 'text') {
    return looksLikeProse(payload.left || '', payload.right || '') ? diffProse(payload) : diffText(payload);
  }
  if (format === 'json' || format === 'yaml') return diffJson(payload);
  if (format === 'csv' || format === 'tsv') return diffCsv(payload);
  return stubCompare(payload);
}
